import React from "react";
import { Navigate } from "react-router-dom";

export function Landing() {
  // Auth is gated upstream by <AuthGate> (sign-in splash / redirect to
  // /sso/start), so by the time Landing renders the user is authenticated.
  // Land on the org Overview — the new fleet-first home.
  return <Navigate to="/overview" replace />;
}
